// Components
import { Spinner } from '@/ui';
import ChangeOrderStatus from '../ChangeOrderStatus/ChangeOrderStatus';
import OrderDetails from '../OrderDetails/OrderDetails';
import { StyledContainer } from './AdDetailsStyles';

// Models
import { IOrder, OrderStatus } from '@/models/order.model';

type TDocumentsDetails = {
  order: IOrder;
  isLoading: boolean;
  onChangeStatus: (status: OrderStatus) => void;
};

const AdDetails = ({ isLoading, order, onChangeStatus }: TDocumentsDetails) => {
  return (
    <Spinner spinning={isLoading}>
      <StyledContainer>
        <OrderDetails order={order} />
        <ChangeOrderStatus value={order.status} loading={isLoading} onChange={onChangeStatus} />
      </StyledContainer>
    </Spinner>
  );
};

export default AdDetails;
